<tt-form-field-base
    [ttRememberId]="ttRememberId"
    [ttRememberDebounceTime]="ttRememberDebounceTime"
    [ttFieldId]="id.input"
    [ttLabel]="ttLabel"
    [ttLabelView]="ttLabelView"
    [ttTranslateLabel]="ttTranslateLabel"
    [ttSublabel]="ttSublabel"
    [ttTranslateSublabel]="ttTranslateSublabel"
    [ttToggleTipText]="ttToggleTipText"
    [ttTranslateToggleTipText]="ttTranslateToggleTipText"
    [ttInvalid]="ttInvalid"
    [ttInvalidText]="ttInvalidText"
    [ttTranslateInvalidText]="ttTranslateInvalidText"
    [ttTextAlign]="ttTextAlign"
    [ttRequired]="ttRequired"
    [ttReadonly]="ttReadonly"
    [ttDisabled]="ttDisabled"
    [ttStyle]="ttStyle"
>
    <input
        #inputRef
        [tabindex]="!!ttTabable ? '0' : '-1'"
        class="tt-input__form-control"
        [attr.inputmode]="inputmode"
        type="text"
        [attr.id]="id.input"
        [(ngModel)]="_viewValue"
        (ngModelChange)="onModelChanged($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        [ngStyle]="style['input']"
        [readOnly]="ttReadonly"
        [disabled]="ttDisabled"
    />
    <ng-container buttons>
        <tt-form-field-button *ngIf="ttShowClearButton" ttId="$clear" ttIcon="fas fa-eraser" ttType="danger" (ttClick)="onModelChanged('')"></tt-form-field-button>
        <ng-container *ngIf="ttShowSteppers">
            <tt-form-field-button ttIcon="fas fa-minus" ttType="primary" [ttDisabled]="ttReadonly || ttDisabled" (ttClick)="stepValue($event.event, -1)"></tt-form-field-button>
            <tt-form-field-button ttIcon="fas fa-plus" ttType="primary" [ttDisabled]="ttReadonly || ttDisabled" (ttClick)="stepValue($event.event, 1)"></tt-form-field-button>
        </ng-container>
        <tt-form-field-buttons *ngIf="ttButtons" [ttButtons]="ttButtons" [ttButtonParms]="ttButtonParms"></tt-form-field-buttons>
        <ng-content select="[buttons]"></ng-content>
    </ng-container>
</tt-form-field-base>
